import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useRegistrationStore } from '~/stores/registration'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    const registrationStore = useRegistrationStore()

    if (to.name === 'account-nieuwe-hulpvraag-check') {
      if (!registrationStore.formProgress.matchRequest.isConfirmStep) {
        return navigateTo({
          name: 'account-nieuwe-hulpvraag'
        })
      } else if (registrationStore.formProgress.matchRequest.hasSubmitted) {
        return navigateTo({ name: 'account' })
      }
    }

    if (to.name === 'account-nieuwe-hulpvraag') {
      if (registrationStore.formProgress.matchRequest.isConfirmStep) {
        return navigateTo({ name: 'account-nieuwe-hulpvraag-check' })
      } else if (registrationStore.formProgress.matchRequest.hasSubmitted) {
        return navigateTo({ name: 'account' })
      }
    }
  } else if (import.meta.client) {
    const registrationStore = useRegistrationStore()

    if (to.name === 'account-nieuwe-hulpvraag-check') {
      if (!registrationStore.matchRequest.mealWishesStep.helpCookDescription) {
        return navigateTo({
          name: 'account-nieuwe-hulpvraag'
        })
      }
    }
  }
})
